import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SameTinOnInvoiceToReceiptWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.tin.same-tin-on-invoice-to-receipt');
    }
}
